module.exports = __webpack_public_path__ + "static/media/favicon.f057e7a5.ico";